var Model = require("../types/Model.js");

module.exports = Model({
	name: "managedmanagegroupmanagers",
	init: init,
	uninit: uninit,
	listeners: listeners,

	refresh: refresh,
	recalculate: recalculate,
	track_people: track_people,
	reset: reset
});

function init() {
	this._group = null;
	this._group_tracker = this.dispatcher.createTracker();
	this._managers = [];
	this._people = {};

	this.push([]);
}

function uninit() {
	this._managers = null;
	this._group = null;
	this._group_tracker.off();
	this._group_tracker = null;
}

function listeners() {
	return {
		"connectivity:online": refresh,
		"people:updated": Model.makeRecalculator("people"),
		"managedaccount:updated": handle_managegroup_update
	};
}

function handle_managegroup_update(data){
	if (!data || !data.data || !data.data.manage_group) return;
	var group = data.data.manage_group;
	if(!group) this.reset();
	this._group = group;
	this.refresh();
}

function recalculate(){
	const people = this._people;
	const managers = this._managers;

	const processed = managers.reduce((r, m) => {
		const person = people[m];
		if(!person) return r;
		r = r.concat(person);
		return r;
	}, []);

	this.push(processed);
}

function refresh(){
	var group = this._group;
	if(!group) return;
	return this.api.manage.managegroup.listManagers(group)
		.then(setManagers.bind(this))
		.then(trackGroup.bind(this))
		.catch(console.info);
}

function setManagers(managers){
	this._managers = managers;
	this.track_people(managers);
	this.recalculate();
}

function trackGroup(){
	var group = this._group;
	if(!group) return;

	var tracker = this._group_tracker;
	tracker.off();
	tracker.on(`mqtt:managegroup/${group}/managers/added`, handle_manager_added.bind(this));
	tracker.on(`mqtt:managegroup/${group}/managers/removed`, handle_manager_removed.bind(this));
}

function handle_manager_added(data){
	const manager = data.manager;
	const current = this._managers;
	const newList = current.concat(manager);

	this._managers = newList;
	this.track_people(manager);
	this.recalculate();
}

function handle_manager_removed(data){
	const manager = data.manager;
	const current = this._managers;
	const newList = current.filter(e => e !== manager);

	this._managers = newList;
	this.recalculate();
}

function track_people(managers) {
	this.emit("people:trigger:add", {
		lean: true,
		who: managers
	});
}

function reset(){
	this._managers = [];
	this._group_tracker.off();
	this.push([]);
}
